module.exports = __webpack_public_path__ + "img/chat.e283fafe.png";